mutation DuplicateSmsDripSequence($input: DripSequenceDuplicateInput!) {
    dripSequenceDuplicate(input: $input) {
        dripSequence {
            id
            name
            htmlUrlPath
        }
    }
}
